module.exports = "<router-outlet></router-outlet>\n<!-- <app-footer></app-footer> -->\n"


//////////////////
// WEBPACK FOOTER
// /Users/Putman/Desktop/Javascript Projects/angular-portfolio/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main